// extracted by mini-css-extract-plugin
export default {"emersion":"Emersion_emersion__EzhaH","clear":"Emersion_clear__mzKIy","close":"Emersion_close__T1Vz-","container":"Emersion_container__Xa0x2","error":"Emersion_error__DnsUA"};